<template>
  <div class="app-container">
    <div class="filter-container">
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="开始时间"
        endPlaceholder="截止时间"
      />
      <el-select
        v-model="listQuery.paymentType"
        placeholder="支付方式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <JsonExcel :data="list" style="margin-left: 10px" :fields="fields" name="经营明细表.xls">
        <el-button class="filter-item" icon="el-icon-download">导出</el-button>
      </JsonExcel>
    </div>
    <span style="font-size:24px;font-weight:bold;color:#333;">每日销售额趋势</span>
    <div class="top-view" style="margin-top:20px;">
      <div id="chart1" style="width:100%;heihgt:100%"></div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="orderDate" label="日期"></el-table-column>
      <el-table-column align="center" prop="orderCount" label="订单数量"></el-table-column>
      <el-table-column align="center" prop="totalSales" label="订单金额"></el-table-column>
      <el-table-column
        align="center"
        prop="preferredSales"
        label="优选区销售金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="goodThingSales"
        label="平价区销售金额"
      ></el-table-column>
      <el-table-column align="center" prop="alipaySales" label="支付宝销售金额"></el-table-column>
      <el-table-column align="center" prop="wechatSales" label="微信销售金额"></el-table-column>
      <el-table-column
        align="center"
        prop="balanceSales"
        label="余额支付销售金额"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div class="line"></div>
    <span style="font-size:24px;font-weight:bold;color:#333;">商品销售TOP10</span>
    <div class="bottom-left" id="chart2"></div>
    <el-table
      :data="bottomList"
      style="margin-bottom:20px;"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="goodsName" label="商品名称"></el-table-column>
      <el-table-column align="center" prop="salesAmount" label="销售额"></el-table-column>
      <el-table-column align="center" prop="buyNum" label="销售数量"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getProductSales, getMonthlySalesStatistics, getDailySalesTrends } from "@/api/operation";
import DataPicker from "@/views/components/dataPicker.vue";
import JsonExcel from "vue-json-excel";
import * as echarts from "echarts";

export default {
  components: { DataPicker, JsonExcel },
  filters: {},
  data() {
    return {
      fields: {
        日期: "salesDate",
        订单数量: "orderCount",
        订单金额: "totalSales",
        优选区销售金额: "preferredSales",
        平价区销售金额: "goodThingSales",
        支付宝销售金额: "alipaySales",
        微信销售金额: "wechatSales",
        余额支付销售金额: "balanceSales"
      },
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        paymentType: null
      },
      options: [
        { key: "wechat", value: "微信" },
        { key: "alipay", value: "支付宝" },
        { key: "balance", value: "现金余额" }
      ],
      chart1: null,
      chart2: null,
      bottomList: []
    };
  },
  created() {
    let _this = this;
    window.addEventListener("resize", function() {
      if (_this.chart1) {
        _this.chart1.resize();
      }
      if (_this.chart2) {
        _this.chart2.resize();
      }
    });
    this.dailySalesTrends();
    this.productSales();
    this.getList();
  },
  beforeDestroy() {
    if (this.chart1) {
      this.chart1.dispose();
      this.chart1 = null;
    }
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
  },
  methods: {
    productSales() {
      getProductSales().then(res => {
        this.bottomList = res.data;
        this.initChartsTwo();
      });
    },
    initChartsOne(data = null) {
      let chartDom = document.getElementById("chart1");
      this.chart1 = echarts.init(chartDom);
      let arr = [];
      let time = [];
      data.forEach(item => {
        arr.push(item.dailySales);
        time.push(item.orderDate.slice(5));
      });
      let option;

      option = {
        xAxis: {
          type: "category",
          data: time
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: arr,
            type: "bar",
            itemStyle: {
              color: "#587bf3"
            }
          }
        ],
        tooltip: { trigger: "axis", axisPointer: { type: "line" } }
      };

      option && this.chart1.setOption(option);
    },
    initChartsTwo() {
      let chartDom = document.getElementById("chart2");
      this.chart2 = echarts.init(chartDom);
      let arr = [];
      let time = [];
      let data = JSON.parse(JSON.stringify(this.bottomList));
      data = data.sort((a, b) => {
        return a.salesAmount - b.salesAmount;
      });
      data.forEach(item => {
        arr.push(item.goodsName.substring(0, 8));
        time.push(item.salesAmount);
      });
      let option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          }
        },
        grid: {
          left: "15%"
        },
        legend: {},
        xAxis: {
          type: "value"
        },
        yAxis: {
          type: "category",
          data: arr
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              color: "#587bf3"
            },
            label: {
              show: true
            },
            data: time
          }
        ]
      };

      option && this.chart2.setOption(option);
    },
    dailySalesTrends() {
      getDailySalesTrends().then(res => {
        this.initChartsOne(res.data);
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getMonthlySalesStatistics(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 发货 end
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    }
  }
};
</script>
<style scoped lang="scss">
.top-view {
  width: 100%;
  display: flex;
  height: 300px;
  min-height: 300px;
  margin-bottom: 20px;
}
.line {
  width: 100%;
  height: 3px;
  background: #eee;
  margin-top: 100px;
  margin-bottom: 20px;
}
.bottom-left {
  width: 100%;
  height: 300px;
}
.bottom-view {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 400px;

  .bottom-right {
    width: 48%;
    height: 100%;
  }
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
